import styled from 'styled-components';
import { COLORS, FONTS, SIZE, FONT_SIZE } from '@app/src/ui';

interface Props {
  color: string;
}

export const Item = styled.li`
  position: relative;
  &:not(:last-child) {
    border-bottom: 1px solid ${COLORS.GRAY};
  }
`;

export const Title = styled.h3`
  color: ${COLORS.BLACK};
  font-family: ${FONTS.OPEN_SANS};
  font-size: 16px;
  max-width: 90%;

  @media (min-width: ${SIZE.TABLET_LANDSCAPE}) {
    font-size: 18px;
  }
`;

export const Day = styled.span`
  font-size: ${FONT_SIZE.SHORT};

  @media (min-width: ${SIZE.TABLET_LANDSCAPE}) {
    font-size: 18px;
  }
`;

export const Subtitle = styled.p`
  font-family: ${FONTS.OPEN_SANS};
  font-size: 12px;
  color: ${COLORS.GRAY_DARK};

  @media (min-width: ${SIZE.TABLET_LANDSCAPE}) {
    font-size: 14px;
  }
`;

export const Price = styled.span`
  font-weight: 600;
`;

export const TabItem = styled.div`
  position: relative;
  padding: 11px 16px;
  cursor: pointer;
`;

export const IconWrapper = styled.span`
  position: absolute;
  top: 50%;
  right: 17px;
  transform: translateY(-50%);
  svg {
    transform: rotate(-90deg);
  }
`;

export const Counter = styled.span`
  width: 14px;
  height: 14px;
  border-radius: 100%;
  background: ${(props: Props) => props.color};
  color: #fff;
  font-size: 9px;
  font-family: ${FONTS.OPEN_SANS};
  display: inline-flex;
  justify-content: center;
  align-items: center;
  font-weight: 600;
  & ~ svg {
    margin-left: 6px;
  }
`;

export const Summary = styled.div`
  background: ${COLORS.WHITE_DARK};
  margin: 0 16px 11px;
  padding: 8px 32px 8px 10px;
  position: relative;
`;

export const Publications = styled.h4`
  color: ${COLORS.GRAY_TEXT};
  font-family: ${FONTS.OPEN_SANS};
  font-size: 10px;

  @media (min-width: ${SIZE.TABLET_LANDSCAPE}) {
    font-size: 12px;
  }
`;

export const Description = styled.span`
  color: #333;
  font-family: ${FONTS.OPEN_SANS};
  font-size: 11px;

  @media (min-width: ${SIZE.TABLET_LANDSCAPE}) {
    font-size: 14px;
  }
`;

export const Content = styled.div`
  span:not(:first-child) {
    &:before {
      content: ',';
      margin-right: 4px;
    }
  }
`;

export const IconTrash = styled.span`
  position: absolute;
  right: 0;
  top: 0;
  width: 22px;
  height: 100%;
  background: ${COLORS.GRAY_LIGHT};
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
`;

export const Subtotal = styled.p`
  font-family: ${FONTS.OPEN_SANS};
  font-size: 10px;
  font-weight: 600;
  text-align: right;
  margin-top: 4px;

  @media (min-width: ${SIZE.TABLET_LANDSCAPE}) {
    font-size: 14px;
  }
`;
